<template>
  <div class="header-top">
    <div class="selects">
      <div class="fl selects-area" @click="changeModel(1)">
        <SelectArea :defaultValue="areaValue"></SelectArea>
      </div>
      <div class="fl  selects-date" @click="changeModel(2)">
        <selectDate :value="dateString"></selectDate>
      </div>
      <div class="fl  search-bar" @click="changeModel(3)">
        <img src="../../../assets/app/99-magnifier.gif"/>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="all">
      <div class="all-item-01">
        <font class="number" v-text="data.family"></font>
        <font class="desc">（户）</font>
      </div>
    </div>
    <div class="rates">
      <div class="items">
        <div class="item">昨日值</div>
        <div class="item item-rate" :class="{'item-rate-active': Number(data.yesday) >= 0}"> {{data.yesday }}</div>
      </div>
      <div class="items">
        <div class="item">比昨日</div>
        <div class="item item-rate" :class="{'item-rate-active': vdValue(data.compareDay)}">
          <img v-if="vdValue(data.compareDay)" class="item-img" src="../../../assets/app/up.png" alt="">
          <img v-if="!vdValue(data.compareDay)" class="item-img" src="../../../assets/app/down.png" alt="">
          {{data.compareDay}}








        </div>
      </div>
    </div>
    <area-picker :showModel="showModel" @hide="hideModel"></area-picker>
    <ModelDate :dateValue="dateValue" :showModel="showModelDate" @hide="hideModel" @ok="submitDateModel"></ModelDate>
    <SearchBar :showModel="showSearchBar" @hide="hideModel"></SearchBar>
  </div>
</template>
<script>
  import {Toast} from "mint-ui";
  import Popup from 'com/app/common/popup.vue';
  import SelectArea from "com/app/add/selectArea.vue";
  import selectDate from "com/app/add/selectDate.vue";
  import AreaPicker from "com/app/setMeal/areaPicker.vue";
  import ModelDate from "com/app/add/modelDate.vue";
  import SearchBar from "com/app/setMeal/searchBar.vue";
  import {formatDateTime} from "libs/common/common";
  export default {
    components: {
      Popup,
      SelectArea,
      selectDate,
      AreaPicker,
      ModelDate,
      SearchBar
    },
    props: {
      data: {
        type: Object,
        default: {
          family: '0',//新增总用户数
          lastMonth: '0',//上月
          lastYear: '0',//上年
        },
      }
    },
    computed: {
      model() {
        return this.$store.state.meal.model;
      },
      date() {
        return this.$store.state.meal.date;
      }
    },
    watch: {
      model (val) {
        console.info("modelChange", val);
        this.areaValue = val.name;
        this.$emit("fetchData");
      },
      date (val) {
        this.dateValue = val;
        this.dateString = formatDateTime(val, "YYYY-MM-DD");
        console.info("dateChange", this.dateString);
        this.$emit("fetchData");
      }
    },
    data() {
      return {
        showSearchBar: false,
        areaValue: "",
        dateString: "",
        dateValue: "",
        showModel: false,
        showModelDate: false
      }
    },
    methods: {
      vdValue(value){
        let flag = false;
        value = value.slice(0, value.length - 2);
        if (Number(value) >= 0) {
          flag = true;
        }
        return flag;
      },
      changeModel(type) {
        if (type === 1) {
          this.showModel = true;
        } else if (type === 2) {
          this.showModelDate = true;
        } else {
          this.showSearchBar = true;
        }
      },
      hideModel () {
        this.showModel = false;
        this.showModelDate = false;
        this.showSearchBar = false;
      },
      submitDateModel(date){
        if (formatDateTime(date, "YYYY-MM-DD") !== formatDateTime(this.dateValue, "YYYY-MM-DD")) {
          this.$store.commit("SAVE_MEAL_DATE", {
            date: date
          });
        }
        this.hideModel();
      }
    },
    created() {
      let meal = this.$store.state.meal;
      this.dateValue = meal.date;
      this.dateString = formatDateTime(meal.date, "YYYY-MM-DD");
      this.$store.commit("SAVE_MEAL_XID", {
        xid: this.$route.query.xid
      });
    }
  }

</script>
<style lang="less" scoped>
  .font-family-fn(@family) {
    font-family: @family;
  }

  .header-top {
    background-color: none;
    .selects {
      height: 0.8rem;
      font-size: 0.3rem;
      margin-top: 0.2rem;
      .selects-area,
      .selects-date {
        width: 2.8rem;
      }
      .selects-area {
        margin-left: .49rem;
        margin-right: .24rem;
      }
      .selects-date {
        margin-right: .19rem !important;
      }
      .search-bar {
        img {
          margin-top: .08rem;
          width: .49rem;
          height: .49rem;
        }
      }
    }
    .mint-header {
      height: 0.8rem;
      background-color: #0384df;
      z-index: 9;
      .mint-header-title {
        font-size: 0.36rem;
        font-weight: normal;
        .font-family-fn("PingFang-SC-Medium");
      }
      .mintui {
        font-size: 0.36rem;
      }
      .star {
        width: 0.45rem;
      }
    }
    .all {
      color: #FFF;
      text-align: center;
      position: relative;
      font-size: 0.26rem;
      margin-top: .35rem;
      display: flex;
      .all-item-01 {
        flex: 1;
      }
      .all-item-02 {
        .font-family-fn("PingFang-SC-Regular");
        font-weight: 300;
        position: absolute;
        right: 0.5rem;
        top: 0.85rem;
        .question {
          position: relative;
          top: 2px;
          width: 0.25rem;
        }
        .mouth {
          font-size: 0.26rem;
        }
      }
      .number {
        font-size: 0.63rem;
        .font-family-fn("PingFang-SC-Heavy");
      }
      .desc {
        font-weight: 300;
        position: absolute;
        font-size: 0.24rem;
        top: 0.4rem;
      }
    }
    .rates {
      font-weight: 300;
      padding-top: 0.4rem;
      color: #FFF;
      display: flex;
      margin: 0 0.61rem;
      text-align: center;
      .items {
        font-size: 0.29rem;
        flex: 1;
        display: flex;
        .item {
          .font-family-fn("PingFang-SC-Regular");
          flex: 1;
          .item-img {
            width: 0.1rem;
          }
        }
        .item-rate {
          .font-family-fn("PingFang-SC-Bold");
          text-align: center;
          color: #4CFF65;
        }
        .item-rate-active {
          color: #FCC92E;
        }
      }
    }
  }

  .popup-content {
    padding: 0.2rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/app/setMeal/headerTop.vue